import type {
  AttributeAccumulationConfig,
  IAnalyticExpressionPredictorConfig,
  IAutoMLPredictorConfig,
  IChemicalFormulaFeaturizerPredictorConfig,
  IExpressionMLPredictorConfig,
  IGeneralizedMeanPropertyPredictorConfig,
  IIngredientFractionsPredictorConfig,
  IIngredientsToSimpleMixturePredictorConfig,
  ILabelFractionsPredictorConfig,
  IMeanPropertyPredictorConfig,
  IMoleculeFeaturizerPredictorConfig,
  ISimpleMLPredictorConfig,
  ISimpleMixturePredictorConfig,
  ScalarPredictorConfig,
} from "../predictor";
import { isOfType } from "../utils";

/**
 * AutoML
 */
export const isAutoMLPredictorConfig = isOfType<
  IAutoMLPredictorConfig,
  ScalarPredictorConfig
>("AutoML");

/**
 * AttributeAccumulation
 */
export const isAttributeAccumulationPredictorConfig = isOfType<
  AttributeAccumulationConfig,
  ScalarPredictorConfig
>("AttributeAccumulation");

/**
 * Simple
 */
export const isSimpleMLPredictorConfig = isOfType<
  ISimpleMLPredictorConfig,
  ScalarPredictorConfig
>("Simple");

/**
 * Expression
 */
export const isExpressionMLPredictorConfig = isOfType<
  IExpressionMLPredictorConfig,
  ScalarPredictorConfig
>("Expression");

/**
 * Analytic Expression
 */
export const isAnalyticExpressionPredictorConfig = isOfType<
  IAnalyticExpressionPredictorConfig,
  ScalarPredictorConfig
>("AnalyticExpression");

export const isExpressionOrLegacyExpressionPredictorConfig = isOfType<
  IExpressionMLPredictorConfig | IAnalyticExpressionPredictorConfig,
  ScalarPredictorConfig
>("Expression", "AnalyticExpression");

/**
 * Formulations
 */
export const isGeneralizedMeanPropertyPredictorConfig = isOfType<
  IGeneralizedMeanPropertyPredictorConfig,
  ScalarPredictorConfig
>("GeneralizedMeanProperty");

export const isMeanPropertyPredictorConfig = isOfType<
  IMeanPropertyPredictorConfig,
  ScalarPredictorConfig
>("MeanProperty");

export const isSimpleMixturePredictorConfig = isOfType<
  ISimpleMixturePredictorConfig,
  ScalarPredictorConfig
>("SimpleMixture");

export const isIngredientsToSimpleMixturePredictorConfig = isOfType<
  IIngredientsToSimpleMixturePredictorConfig,
  ScalarPredictorConfig
>("IngredientsToSimpleMixture");

export const isIngredientFractionsPredictorConfig = isOfType<
  IIngredientFractionsPredictorConfig,
  ScalarPredictorConfig
>("IngredientFractions");

export const isLabelFractionsPredictorConfig = isOfType<
  ILabelFractionsPredictorConfig,
  ScalarPredictorConfig
>("LabelFractions");

export const isMoleculeFeaturizerPredictorConfig = isOfType<
  IMoleculeFeaturizerPredictorConfig,
  ScalarPredictorConfig
>("MoleculeFeaturizer");

export const isChemicalFormulaFeaturizerPredictorConfig = isOfType<
  IChemicalFormulaFeaturizerPredictorConfig,
  ScalarPredictorConfig
>("ChemicalFormulaFeaturizer");

export type IFeaturizerPredictorConfig =
  | IIngredientFractionsPredictorConfig
  | ILabelFractionsPredictorConfig
  | IMeanPropertyPredictorConfig
  | IChemicalFormulaFeaturizerPredictorConfig
  | IMoleculeFeaturizerPredictorConfig;

export const isFeaturizerPredictorConfig = isOfType<
  IFeaturizerPredictorConfig,
  ScalarPredictorConfig
>(
  "ChemicalFormulaFeaturizer",
  "IngredientFractions",
  "LabelFractions",
  "MeanProperty",
  "MoleculeFeaturizer",
);

type FormulationPredictorConfig =
  | IGeneralizedMeanPropertyPredictorConfig
  | IIngredientFractionsPredictorConfig
  | IIngredientsToSimpleMixturePredictorConfig
  | ILabelFractionsPredictorConfig
  | IMeanPropertyPredictorConfig
  | ISimpleMixturePredictorConfig;

export const isFormulationPredictorConfig = isOfType<
  FormulationPredictorConfig,
  ScalarPredictorConfig
>(
  "IngredientsToSimpleMixture",
  "GeneralizedMeanProperty",
  "MeanProperty",
  "SimpleMixture",
  "LabelFractions",
  "IngredientFractions",
);
